import { render, staticRenderFns } from "./wjnotree.vue?vue&type=template&id=70c119c2"
import script from "./wjnotree.vue?vue&type=script&lang=js"
export * from "./wjnotree.vue?vue&type=script&lang=js"
import style0 from "./wjnotree.vue?vue&type=style&index=0&id=70c119c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports